const Gradient = () => {

    return (
        <div className="bg-main">
            <div className="bg-colors"></div>
        </div>
    )
}

export default Gradient;